import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App.jsx";
import "./styles/index.css";
import TelemetryProvider from "./utils/TelemetryProvider.jsx";
import { initSentry, captureException } from "./utils/sentry.js";

// Initialize Sentry before render
try {
  initSentry();
} catch (err) {
  console.warn("Sentry init failed:", err);
}

// Global error handlers
window.onerror = function (message, source, lineno, colno, error) {
  try {
    captureException(error || new Error(String(message)));
  } catch (_) {}
};

window.addEventListener("unhandledrejection", (event) => {
  try {
    captureException(event.reason || new Error("Unhandled rejection"));
  } catch (_) {}
});

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")).render(
  <TelemetryProvider>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </TelemetryProvider>
);
